// src/utils/ticketGenerator.js
import { obtenerDatosEmpresa } from './tenantConfig';

// Configuración por defecto (fallback)
export const JEAN_INFORMATICO_CONFIG = {
  nombre: "JEAN INFORMATICO C.A",
  rif: "41023119-0",
  direccion: "C.C. LATIN CENTER PB LOCAL 01",
  telefono1: "04125696219",
  telefono2: "0416-7594723",
  ciudad: "ACARIGUA - PORTUGUESA",
  email: "jean.informatico@gmail.com",
  slogan: "Servicio Técnico Especializado",
  whatsapp: "04167594723",
  instagram: "@jeaninformatico",
  facebook: "Jean Informatico",
  tiktok: "@jeaninformatico",
  condiciones: [
    "Este ticket es necesario para retirar el equipo",
    "Diagnóstico tiene costo de $10 (si no se repara)",
    "Se contactará por teléfono para presupuesto",
    "Tiempo estimado: 3-5 días hábiles",
    "Equipos no reclamados en 30 días pasan a disposición del taller"
  ]
};

// Re-exportar funciones útiles de facturaGenerator
export {
  formatearNumero,
  formatearPrecio,
  calcularTotalBolivares
} from './facturaGenerator';

export const formatearGarantiaMostrar = (dias) => {
  if (!dias || dias === 0) return '';
  if (dias >= 365) return `${Math.floor(dias / 365)} año${Math.floor(dias / 365) !== 1 ? 's' : ''}`;
  if (dias >= 30) return `${Math.floor(dias / 30)} mes${Math.floor(dias / 30) !== 1 ? 'es' : ''}`;
  return `${dias} día${dias !== 1 ? 's' : ''}`;
};

export const generarNumeroTicket = (numeroOrden) => {
  const fecha = new Date();
  const año = fecha.getFullYear().toString().slice(-2);
  const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
  const dia = fecha.getDate().toString().padStart(2, '0');
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `JEAN-TKT-${año}${mes}${dia}-${random}`;
};

export const formatearFechaTicket = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const d = new Date(fechaISO);
    const dd = d.getDate().toString().padStart(2, '0');
    const mm = (d.getMonth() + 1).toString().padStart(2, '0');
    const yy = d.getFullYear();
    return `${dd}/${mm}/${yy}`;
  } catch {
    return fechaISO;
  }
};

export const formatearHoraTicket = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const d = new Date(fechaISO);
    const hh = d.getHours().toString().padStart(2, '0');
    const mm = d.getMinutes().toString().padStart(2, '0');
    return `${hh}:${mm}`;
  } catch {
    return '--:--';
  }
};

export const formatearHora12 = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const d = new Date(fechaISO);
    let horas = d.getHours();
    const minutos = d.getMinutes().toString().padStart(2, '0');
    const ampm = horas >= 12 ? 'PM' : 'AM';
    horas = horas % 12 || 12;
    return `${horas}:${minutos} ${ampm}`;
  } catch {
    return '--:--';
  }
};

export const obtenerDiaSemana = (fechaISO) => {
  if (!fechaISO) return '';
  try {
    const d = new Date(fechaISO);
    const dias = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
    return dias[d.getDay()];
  } catch {
    return '';
  }
};

export const formatearFechaCompleta = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const d = new Date(fechaISO);
    const fecha = formatearFechaTicket(fechaISO);
    const hora12 = formatearHora12(fechaISO);
    const diaSemana = obtenerDiaSemana(fechaISO);
    return `${diaSemana} ${fecha} - ${hora12}`;
  } catch {
    return fechaISO;
  }
};

export const formatearMonto = (monto) => {
  if (monto === null || monto === undefined || isNaN(monto)) return 'Bs 0,00';
  return `Bs ${parseFloat(monto).toFixed(2).replace('.', ',')}`;
};

const esOrdenEntregada = (orden) => {
  const estadoNombre = (orden.nombreEstado || orden.NombreEstado || orden.estado || orden.Estado || '').toLowerCase();
  return estadoNombre.includes('entregado') || estadoNombre.includes('entregada');
};

const obtenerNombreMetodoPago = (orden, pagoInfo) => {
  if (pagoInfo?.metodoPago) return pagoInfo.metodoPago;
  if (pagoInfo?.metodoPagoNombre) return pagoInfo.metodoPagoNombre;
  if (orden.metodoPago) return orden.metodoPago;
  if (orden.MetodoPago) return orden.MetodoPago;
  if (orden.pagos && orden.pagos.length > 0) {
    const pago = orden.pagos[0];
    if (pago.metodoPago) return pago.metodoPago;
    if (pago.metodoPagoNombre) return pago.metodoPagoNombre;
  }
  return 'NO REGISTRADO';
};

const obtenerReferenciaPago = (orden, pagoInfo) => {
  if (pagoInfo?.referencia) return pagoInfo.referencia;
  if (orden.referenciaPago) return orden.referenciaPago;
  if (orden.referencia) return orden.referencia;
  if (orden.pagos && orden.pagos.length > 0 && orden.pagos[0].referencia) {
    return orden.pagos[0].referencia;
  }
  return 'S/R';
};

const calcularGarantiaMaxima = (orden) => {
  let maxGarantia = 0;
  if (orden.servicios && orden.servicios.length > 0) {
    orden.servicios.forEach(servicio => {
      const garantia = servicio.garantia || servicio.garantiaDias || 0;
      if (garantia > maxGarantia) maxGarantia = garantia;
    });
  }
  if (orden.productos && orden.productos.length > 0) {
    orden.productos.forEach(producto => {
      const garantia = producto.garantia || producto.garantiaDias || 0;
      if (garantia > maxGarantia) maxGarantia = garantia;
    });
  }
  return maxGarantia;
};

export const generarHTMLTicketDiagnostico = (orden, cliente, tecnico) => {
  const empresa = obtenerDatosEmpresa(); // 👈 config dinámica
  const fecha = new Date();
  const fechaRegistro = orden.fechaCreacion || orden.fechaRegistro || orden.createdAt || orden.fecha || fecha;
  const esDiagnosticoGratis = !orden.tipoDiagnostico || orden.tipoDiagnostico === 'GRATIS';
  const badgeTexto = orden.tipoDiagnostico === 'ADELANTADO' ? 'PAGO ADELANTADO' : (esDiagnosticoGratis ? 'DIAGNÓSTICO GRATIS' : 'DIAGNÓSTICO EXPRESS $10');

  const accesorios = orden.accesorios || orden.accesoriosEquipo || 'NINGUNO';
  const equipoDescripcion = orden.equipo || orden.descripcionEquipo || orden.descripcion || 'N/D';

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Ticket Recepción ${empresa.nombreComercial}</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Courier New', monospace; background: #fff; color: #000; width: 58mm; font-size: 10px; line-height: 1.2; font-weight: 700; text-transform: uppercase; text-align: center; margin: 0 auto; padding: 0; }
        .ticket-wrapper { width: 48mm; padding: 1mm 0; margin: 0 auto; text-align: center; word-wrap: break-word; }
        .logo-img { width: 48mm; max-width: 48mm; margin: 0 auto; padding: 0; display: block; }
        .linea { text-align: center; margin: 0.5mm 0; word-wrap: break-word; }
        .bold { font-weight: 900; }
        .separador { text-align: center; margin: 0.5mm 0; }
        @media print { @page { size: 58mm auto; margin: 0; } .no-print { display: none; } }
      </style>
    </head>
    <body>
      <div class="ticket-wrapper">
        <img src="${empresa.logoBase64}" alt="Logo" class="logo-img" />
        <div class="linea">${empresa.direccion}</div>
        <div class="linea">${empresa.ciudad}</div>
        <div class="linea">${empresa.telefono1} / ${empresa.whatsapp}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">${badgeTexto}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">ORDEN: #${orden.numeroOrden || 'N/A'}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">FECHA DE REGISTRO</div>
        <div class="linea">${formatearFechaCompleta(fechaRegistro)}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">DATOS DEL CLIENTE</div>
        <div class="linea">${(cliente?.nombre || '') + ' ' + (cliente?.apellido || '')}</div>
        <div class="linea">${cliente?.telefono || 'N/D'}</div>
        <div class="linea">${cliente?.documento || 'N/D'}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">DATOS DEL EQUIPO</div>
        <div class="linea">${equipoDescripcion}</div>
        <div class="linea">DESC: ${orden.descripcion || 'N/D'}</div>
        <div class="linea">PROB: ${orden.problema || 'N/D'}</div>
        <div class="linea bold">ACCESORIOS: ${accesorios}</div>
        ${(orden.items && orden.items.length > 0) ? `
        <div class="separador">----------------------------</div>
        <div class="linea bold">SERVICIOS / PRODUCTOS</div>
        ${orden.items.map(it => `<div class="linea">${(it.cantidad && it.cantidad > 1) ? `${it.cantidad}x ` : ''}${it.nombre} - $${Number(it.precio_total || it.precio || 0).toFixed(2)}</div>`).join('')}
        <div class="linea bold">COSTO ACORDADO: $${Number(orden.precioTotalUsd || orden.montoAcordado || 0).toFixed(2)}</div>
        ` : (orden.servicioAcordado ? `
        <div class="separador">----------------------------</div>
        <div class="linea bold">SERVICIO / REPARACIÓN</div>
        <div class="linea">${orden.servicioAcordado}</div>
        ${(orden.precioTotalUsd || orden.montoAcordado) ? `<div class="linea bold">COSTO ACORDADO: $${Number(orden.precioTotalUsd || orden.montoAcordado).toFixed(2)}</div>` : ''}
        ` : '')}
        ${(orden.montoPagadoUsd > 0 || orden.montoDiagnostico > 0 || orden.metodoPagoExpress) ? `
        <div class="separador">----------------------------</div>
        <div class="linea bold">PAGO EN RECEPCIÓN</div>
        <div class="linea">MONTO: $${Number(orden.montoPagadoUsd || orden.montoDiagnostico || 0).toFixed(2)}</div>
        <div class="linea">METODO: ${orden.metodoPago || orden.metodoPagoExpress || 'EFECTIVO'}</div>
        ${(orden.referencia || orden.referenciaPago) ? `<div class="linea">REF: ${orden.referencia || orden.referenciaPago}</div>` : ''}
        ${(Number(orden.precioTotalUsd || orden.montoAcordado || 0) > Number(orden.montoPagadoUsd || 0)) ? `
        <div class="linea bold">SALDO AL RETIRAR: $${(Number(orden.precioTotalUsd || orden.montoAcordado) - Number(orden.montoPagadoUsd || 0)).toFixed(2)}</div>
        ` : `<div class="linea bold">ESTADO: PAGADO COMPLETO ✅</div>`}
        ` : ''}
        <div class="separador">============================</div>
        <div class="linea bold">⚠️ IMPORTANTE</div>
        <div class="linea">DIAGNÓSTICO 24-78 HORAS HÁBILES</div>
        <div class="separador">----------------------------</div>
        <div class="linea">NOTA: ESTIMADO CLIENTE</div>
        <div class="linea">CUANDO EL EQUIPO ESTÉ</div>
        <div class="linea">REPARADO Y NOTIFICADO</div>
        <div class="linea">TIENE 15 DÍAS HÁBILES</div>
        <div class="linea">PARA RETIRARLO, SINO</div>
        <div class="linea">LA EMPRESA NO SE HACE</div>
        <div class="linea">RESPONSABLE</div>
        <div class="separador">----------------------------</div>
        <div class="linea">ENCUÉNTRANOS EN TODAS</div>
        <div class="linea">LAS REDES COMO:</div>
        <div class="linea bold">${empresa.instagram || '@JEANINFORMATICO'}</div>
      </div>
      
      <div class="no-print" style="text-align: center; margin-top: 10px;">
        <button onclick="window.print()" style="padding: 8px 16px; background: #000; color: white; border: none; cursor: pointer;">🖨️ IMPRIMIR</button>
        <button onclick="window.close()" style="padding: 8px 16px; background: #666; color: white; border: none; cursor: pointer; margin-left: 10px;">✕ CERRAR</button>
      </div>
      
      <script>
        window.onload = function() { setTimeout(function() { window.print(); }, 300); };
        window.onafterprint = function() { setTimeout(function() { window.close(); }, 800); };
      </script>
    </body>
    </html>
  `;
};

export const generarHTMLTicketReparacion = (orden, cliente, tecnico, pagoInfo = null) => {
  const empresa = obtenerDatosEmpresa(); // 👈 config dinámica
  const fecha = new Date();
  const fechaRegistro = orden.fechaCreacion || orden.fechaRegistro || orden.createdAt || orden.fecha || fecha;
  const esEntregada = esOrdenEntregada(orden);
  const garantiaMaxima = calcularGarantiaMaxima(orden);

  const tituloTicket = (esEntregada || (pagoInfo && (pagoInfo.metodoPago || pagoInfo.metodoPagoNombre)) || (orden.montoPagadoUsd || orden.MontoPagadoUsd || 0) > 0 || (orden.tasaBsUsd || 0) > 0) ? 'GARANTÍA Y REPARACIÓN' : 'REPARACIÓN';

  const totalServicios = (orden.servicios || []).reduce((total, servicio) => {
    return total + ((servicio.precioPersonalizado || servicio.precio || 0) * (servicio.cantidad || 1));
  }, 0);

  const totalProductos = (orden.productos || []).reduce((total, producto) => {
    return total + ((producto.precioPersonalizado || producto.precio || 0) * (producto.cantidad || 1));
  }, 0);

  const subtotal = totalServicios + totalProductos;
  const total = subtotal - (orden.descuento || 0);
  const accesorios = orden.accesorios || orden.accesoriosEquipo || 'NINGUNO';
  const equipoDescripcion = orden.equipo || orden.descripcionEquipo || orden.descripcion || 'N/D';

  const metodoPagoTexto = obtenerNombreMetodoPago(orden, pagoInfo);
  const referenciaPago = obtenerReferenciaPago(orden, pagoInfo);
  const fechaEntrega = orden.fechaEntrega || orden.FechaEntrega;
  const fechaPago = orden.fechaPago || orden.FechaPago;
  const montoPagado = orden.montoPagadoUsd || orden.MontoPagadoUsd || total;
  const descuento = orden.descuento || 0;
  const saldoPendiente = total - montoPagado;
  const tasaBsUsd = orden.tasaBsUsd || 0;
  const montoPagadoBs = Number((montoPagado * tasaBsUsd).toFixed(2));
  const saldoPendienteBs = Number((saldoPendiente * tasaBsUsd).toFixed(2));

  const tieneGarantiaIndividual = (orden.servicios && orden.servicios.some(s => (s.garantia || s.garantiaDias || 0) > 0)) ||
    (orden.productos && orden.productos.some(p => (p.garantia || p.garantiaDias || 0) > 0));

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>${tituloTicket} ${empresa.nombreComercial}</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Courier New', monospace; background: #fff; color: #000; width: 58mm; font-size: 10px; line-height: 1.2; font-weight: 700; text-transform: uppercase; text-align: center; margin: 0 auto; padding: 0; }
        .ticket-wrapper { width: 48mm; padding: 1mm 0; margin: 0 auto; text-align: center; word-wrap: break-word; }
        .logo-img { width: 48mm; max-width: 48mm; margin: 0 auto; padding: 0; display: block; }
        .linea { text-align: center; margin: 0.5mm 0; word-wrap: break-word; }
        .bold { font-weight: 900; }
        .separador { text-align: center; margin: 0.5mm 0; }
        @media print { @page { size: 58mm auto; margin: 0; } .no-print { display: none; } }
      </style>
    </head>
    <body>
      <div class="ticket-wrapper">
        <img src="${empresa.logoBase64}" alt="Logo" class="logo-img" />
        <div class="linea">${empresa.direccion}</div>
        <div class="linea">${empresa.ciudad}</div>
        <div class="linea">${empresa.telefono1} / ${empresa.whatsapp}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">${tituloTicket}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">ORDEN: #${orden.numeroOrden || 'N/A'}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">FECHA DE REGISTRO</div>
        <div class="linea">${formatearFechaCompleta(fechaRegistro)}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">DATOS DEL CLIENTE</div>
        <div class="linea">${cliente?.nombre?.toUpperCase() || 'C. FINAL'}</div>
        <div class="linea">${cliente?.telefono || 'N/D'}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">DATOS DEL EQUIPO</div>
        <div class="linea">${equipoDescripcion}</div>
        <div class="linea">DESC: ${orden.descripcion || 'N/D'}</div>
        <div class="linea">PROB: ${orden.problema || 'N/D'}</div>
        <div class="linea bold">ACCESORIOS: ${accesorios}</div>
        <div class="separador">----------------------------</div>
        <div class="linea bold">DETALLE</div>
        ${orden.servicios && orden.servicios.length > 0 ? orden.servicios.map(s => {
          const garantiaItem = s.garantia || s.garantiaDias || 0;
          const garantiaTexto = garantiaItem > 0 ? ` [GARANTÍA: ${formatearGarantiaMostrar(garantiaItem)}]` : '';
          return `<div class="linea">${(s.observaciones || s.nombre || 'SERVICIO').slice(0, 24)}${garantiaTexto}</div><div class="linea">$${(s.precio || 0).toFixed(2)}</div>`;
        }).join('') : ''}
        ${orden.productos && orden.productos.length > 0 ? orden.productos.map(p => {
          const garantiaItem = p.garantia || p.garantiaDias || 0;
          const garantiaTexto = garantiaItem > 0 ? ` [GARANTÍA: ${formatearGarantiaMostrar(garantiaItem)}]` : '';
          return `<div class="linea">${(p.nombre || 'PRODUCTO').slice(0, 24)}${garantiaTexto}</div><div class="linea">$${(p.precio || 0).toFixed(2)}</div>`;
        }).join('') : ''}
        <div class="separador">----------------------------</div>
        <div class="linea">SUBTOTAL: $${subtotal.toFixed(2)}</div>
        ${descuento > 0 ? `<div class="linea">DESCUENTO: -$${descuento.toFixed(2)}</div>` : ''}
        <div class="separador">============================</div>
        <div class="linea bold">TOTAL: $${total.toFixed(2)}</div>
        <div class="separador">============================</div>
        
        ${(esEntregada || (metodoPagoTexto && metodoPagoTexto !== 'NO REGISTRADO')) ? `
        <div class="separador">----------------------------</div>
        <div class="linea bold">INFORMACIÓN DE PAGO</div>
        <div class="linea">METODO: ${metodoPagoTexto}</div>
        <div class="linea">REFERENCIA: ${referenciaPago}</div>
        <div class="linea">MONTO: $${montoPagado.toFixed(2)}</div>
        ${tasaBsUsd ? `<div class="linea">TASA: ${tasaBsUsd}</div>` : ''}
        ${montoPagadoBs > 0 ? `<div class="linea">MONTO BS: Bs ${montoPagadoBs.toFixed(2)}</div>` : ''}
        ${fechaPago ? `<div class="linea">FECHA PAGO: ${formatearFechaCompleta(fechaPago)}</div>` : ''}
        ${saldoPendiente > 0.01 ? `<div class="linea bold">SALDO: $${saldoPendiente.toFixed(2)}</div>` : '<div class="linea bold">ESTADO: CANCELADO</div>'}
        ${saldoPendienteBs > 0.01 ? `<div class="linea bold">SALDO BS: Bs ${saldoPendienteBs.toFixed(2)}</div>` : ''}
        <div class="separador">----------------------------</div>
        ` : ''}
        
        ${tieneGarantiaIndividual ? `
        <div class="separador">----------------------------</div>
        <div class="linea bold">🎯 GARANTÍA DE SERVICIOS Y PRODUCTOS</div>
        ${orden.servicios && orden.servicios.length > 0 ? orden.servicios.map(s => {
          const garantiaItem = s.garantia || s.garantiaDias || 0;
          if (garantiaItem > 0) return `<div class="linea">• ${(s.nombre || 'SERVICIO').slice(0, 20)}: ${formatearGarantiaMostrar(garantiaItem)}</div>`;
          return '';
        }).join('') : ''}
        ${orden.productos && orden.productos.length > 0 ? orden.productos.map(p => {
          const garantiaItem = p.garantia || p.garantiaDias || 0;
          if (garantiaItem > 0) return `<div class="linea">• ${(p.nombre || 'PRODUCTO').slice(0, 20)}: ${formatearGarantiaMostrar(garantiaItem)}</div>`;
          return '';
        }).join('') : ''}
        <div class="separador">----------------------------</div>
        ` : ''}
        
        ${garantiaMaxima > 0 && !tieneGarantiaIndividual ? `<div class="linea bold">GARANTÍA GENERAL: ${formatearGarantiaMostrar(garantiaMaxima)}</div>` : ''}
        ${fechaEntrega ? `<div class="linea">FECHA ENTREGA: ${formatearFechaCompleta(fechaEntrega)}</div>` : ''}

        <div class="separador">----------------------------</div>
        <div class="linea bold">¡GRACIAS POR SU CONFIANZA!</div>
        <div class="linea">ENCUÉNTRANOS EN TODAS</div>
        <div class="linea">LAS REDES COMO:</div>
        <div class="linea bold">${empresa.instagram || '@JEANINFORMATICO'}</div>
        <div class="separador">----------------------------</div>
        <div class="linea">${empresa.slogan}</div>
      </div>
      
      <div class="no-print" style="text-align: center; margin-top: 10px;">
        <button onclick="window.print()" style="padding: 8px 16px; background: #000; color: white; border: none; cursor: pointer;">🖨️ IMPRIMIR</button>
        <button onclick="window.close()" style="padding: 8px 16px; background: #666; color: white; border: none; cursor: pointer; margin-left: 10px;">✕ CERRAR</button>
      </div>
      
      <script>
        window.onload = function() { setTimeout(function() { window.print(); }, 300); };
        window.onafterprint = function() { setTimeout(function() { window.close(); }, 800); };
      </script>
    </body>
    </html>
  `;
};

export const imprimirTicketDiagnostico = (orden, cliente, tecnico) => {
  const htmlTicket = generarHTMLTicketDiagnostico(orden, cliente, tecnico);
  const ventanaTicket = window.open('', '_blank', 'width=400,height=550');
  if (!ventanaTicket) { alert('Por favor permite ventanas emergentes para imprimir el ticket'); return; }
  ventanaTicket.document.write(htmlTicket);
  ventanaTicket.document.close();
};

export const imprimirTicketReparacion = (orden, cliente, tecnico, pagoInfo = null) => {
  const htmlTicket = generarHTMLTicketReparacion(orden, cliente, tecnico, pagoInfo);
  const ventanaTicket = window.open('', '_blank', 'width=400,height=550');
  if (!ventanaTicket) { alert('Por favor permite ventanas emergentes para imprimir el ticket'); return; }
  ventanaTicket.document.write(htmlTicket);
  ventanaTicket.document.close();
};

export const imprimirTicket = (orden, cliente, tecnico, pagoInfo = null) => {
  const detalles = orden.recepcionEquipoDetalles || orden.detalles || [];
  if (detalles.length > 0) {
    if (!orden.servicios || orden.servicios.length === 0) {
      orden.servicios = detalles.filter(d => d.idServicio > 0 || (!d.idServicio && !d.idProducto && d.observaciones?.startsWith('REPUESTO:'))).map(d => ({
        ...d,
        nombre: d.nombreServicio || (d.observaciones && d.observaciones.startsWith('REPUESTO:') ? d.observaciones.replace('REPUESTO:', '').trim() : d.observaciones) || 'Servicio',
        precio: d.precioUnitarioUsd || d.subtotalUsd || 0,
        cantidad: d.cantidad || 1,
        garantia: d.garantiaDias || 0
      }));
    }
    if (!orden.productos || orden.productos.length === 0) {
      orden.productos = detalles.filter(d => d.idProducto > 0).map(d => ({
        ...d,
        nombre: d.nombreProducto || d.nombre || 'Producto',
        precio: d.precioUnitarioUsd || d.subtotalUsd || 0,
        cantidad: d.cantidad || 1,
        garantia: d.garantiaDias || 0
      }));
    }
  }
  const tieneDetalles = (orden.servicios && orden.servicios.length > 0) || (orden.productos && orden.productos.length > 0);
  if (tieneDetalles) {
    imprimirTicketReparacion(orden, cliente, tecnico, pagoInfo);
  } else {
    imprimirTicketDiagnostico(orden, cliente, tecnico);
  }
};

export const imprimirTicketRecepcion = imprimirTicket;

export const generarHTMLTicketGarantia = (orden, cliente, tecnico, pagoInfo = null) => {
  return generarHTMLTicketReparacion(orden, cliente, tecnico, pagoInfo);
};

export const imprimirTicketGarantia = (orden, cliente, tecnico, pagoInfo = null) => {
  const htmlTicket = generarHTMLTicketGarantia(orden, cliente, tecnico, pagoInfo);
  const ventanaTicket = window.open('', '_blank', 'width=400,height=550');
  if (!ventanaTicket) { alert('Por favor permite ventanas emergentes para imprimir el ticket'); return; }
  ventanaTicket.document.write(htmlTicket);
  ventanaTicket.document.close();
};

export default {
  JEAN_INFORMATICO_CONFIG,
  generarNumeroTicket,
  formatearFechaTicket,
  formatearHoraTicket,
  formatearHora12,
  obtenerDiaSemana,
  formatearFechaCompleta,
  formatearMonto,
  formatearGarantiaMostrar,
  generarHTMLTicketDiagnostico,
  generarHTMLTicketReparacion,
  generarHTMLTicketGarantia,
  imprimirTicketDiagnostico,
  imprimirTicketReparacion,
  imprimirTicketGarantia,
  imprimirTicket
};